import { AccountState } from './types'

export const isLoggedIn = (state: AccountState) => state.loggedIn

export const userInfo = (state: AccountState) => state
